import React from 'react'
import PropTypes from 'prop-types'
import { FormattedNumber } from 'belle-js'
import styles from './BannerBalance.module.scss'

const BannerBalance = (props) => {
  const {
    text,
    balance,
  } = props

  return  (
    <div className={styles.BannerBalance} >
      <p className={styles.normalText}>{text}</p>
      <span className={styles.balance}>
        <FormattedNumber
          value={balance}
          format="currencyWithDecimal"
          showNegativeSign={false} />
      </span>
    </div>
  )
}

BannerBalance.defaultProps = {
  text: '',
  balance: null,
}

BannerBalance.propTypes = {
  text: PropTypes.string,
  balance: PropTypes.number,
}

export default BannerBalance



// WEBPACK FOOTER //
// ./src/components/Client/BannerHeader/BannerBalance/BannerBalance.jsx